var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showRecos)?_c('div',{staticClass:"c-rebuy-collection-carousel u-margin-bottom-medium"},[_c('h3',{staticClass:"t-heading-3 u-text-align-center"},[_vm._v(_vm._s(_vm.collectionTitle))]),_vm._v(" "),_c('product-carousel',{attrs:{"products":_vm.products}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }